import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "card mb-4 border-info" }
const _hoisted_4 = {
  key: 0,
  class: "card-body"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "col-md-4 mt-2" }
const _hoisted_14 = { class: "col-md-4 mt-2" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "col-md-4 mt-2" }
const _hoisted_17 = {
  key: 1,
  class: "card-body"
}
const _hoisted_18 = { class: "card border-warning" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6 col-sm-12" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "col-md-6 col-sm-12" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "col-md-4 col-sm-12" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "text-muted" }
const _hoisted_28 = { class: "col-md-4 col-sm-12" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "col-md-4 col-sm-12" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "col-md-12 col-sm-12" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "col-md-12 mt-3" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header bg-info text-white" }, [
          _createElementVNode("h5", { class: "mb-0" }, [
            _createElementVNode("i", { class: "flaticon-file me-2" }),
            _createTextVNode("Informations du contrat actuel ")
          ])
        ], -1)),
        (_ctx.contratActuel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Référence:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.contratActuel.reference || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Emplacement:", -1)),
                  (_ctx.contratActuel.codeemp)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.contratActuel.codeemp.ncode_emp || _ctx.contratActuel.codeemp.codeemp), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Usager actuel:", -1)),
                  (_ctx.contratActuel.matricule)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createTextVNode(_toDisplayString(_ctx.contratActuel.matricule.nom) + " " + _toDisplayString(_ctx.contratActuel.matricule.prenom) + " ", 1),
                        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", _hoisted_11, _toDisplayString(_ctx.contratActuel.matricule.matricule), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.contratActuel.locataire || 'N/A'), 1))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[10] || (_cache[10] = _createElementVNode("strong", null, "Loyer:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatNumber(_ctx.contratActuel.loyer)) + " FCFA ", 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Solde initial:", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.contratActuel.type_solde === 'Avoir' ? 'text-success' : 'text-danger')
                  }, _toDisplayString(_ctx.formatNumber(_ctx.contratActuel.solde_initial)) + " FCFA ", 3),
                  _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("small", _hoisted_15, "(" + _toDisplayString(_ctx.contratActuel.type_solde) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Durée:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.contratActuel.duree || 'N/A'), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("div", { class: "text-center" }, [
                _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                ])
              ], -1)
            ]))]))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card-header bg-warning text-dark" }, [
          _createElementVNode("h5", { class: "mb-0" }, [
            _createElementVNode("i", { class: "flaticon-exchange me-2" }),
            _createTextVNode("Formulaire de mutation ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Form, {
            onSubmit: _ctx.effectuerMutation,
            "validation-schema": _ctx.mutationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", {
                      for: "nouveau_matricule",
                      class: "form-label fw-medium text-black"
                    }, [
                      _createTextVNode(" Nouvel usager "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "nouveau_matricule",
                      modelValue: _ctx.nouveau_matricule,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nouveau_matricule) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          "filter-results": false,
                          "min-chars": 2,
                          "resolve-on-load": false,
                          delay: 0,
                          searchable: true,
                          "options-limit": 300,
                          options: async (query) => {
                        if (query && query.length >= 2) {
                          const results = await _ctx.fetchUsagerOptions(query);
                          if (results && results.length > 0) {
                            return results;
                          } else {
                            return [
                              { value: '', label: 'Aucun usager trouvé' },
                            ];
                          }
                        } else {
                          return [];
                        }
                      }
                        ,
                          noOptionsText: "Tapez au moins deux caractères",
                          placeholder: "Rechercher le nouvel usager"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nouveau_matricule",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Nouvelle référence ", -1)),
                    _createVNode(_component_Field, {
                      name: "nouvelle_reference",
                      type: "text",
                      modelValue: _ctx.nouvelle_reference,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nouvelle_reference) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Référence du nouveau contrat"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nouvelle_reference",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Nouveau solde initial (FCFA) ", -1)),
                    _createVNode(_component_Field, {
                      name: "nouveau_solde_initial",
                      type: "number",
                      modelValue: _ctx.nouveau_solde_initial,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nouveau_solde_initial) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "0",
                      step: "0.01"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("small", _hoisted_27, "Par défaut: " + _toDisplayString(_ctx.formatNumber(_ctx.contratActuel?.solde_initial || 0)) + " FCFA", 1),
                    _createVNode(_component_ErrorMessage, {
                      name: "nouveau_solde_initial",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Type de solde ", -1)),
                    _createVNode(_component_Field, {
                      name: "nouveau_type_solde",
                      modelValue: _ctx.nouveau_type_solde,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nouveau_type_solde) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.typeSoldeOptions,
                          searchable: false,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un type" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nouveau_type_solde",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                      _createTextVNode(" Motif de mutation "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "motif",
                      type: "text",
                      modelValue: _ctx.motif,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.motif) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Motif de la mutation"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "motif",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Observation ", -1)),
                    _createVNode(_component_Field, {
                      name: "observation",
                      modelValue: _ctx.observation,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.observation) = $event)),
                      as: "textarea",
                      rows: "3",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Observations sur la mutation"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "observation",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      class: "btn btn-warning me-3",
                      type: "submit",
                      disabled: _ctx.loading
                    }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37))
                        : _createCommentVNode("", true),
                      _cache[22] || (_cache[22] = _createElementVNode("i", { class: "flaticon-exchange me-2" }, null, -1)),
                      _cache[23] || (_cache[23] = _createTextVNode("Effectuer la mutation ", -1))
                    ], 8, _hoisted_36),
                    _createVNode(_component_router_link, {
                      to: "/liste-contrats",
                      class: "btn btn-secondary"
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("i", { class: "fa fa-times lh-1 me-1" }, null, -1),
                        _createTextVNode(" Annuler ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ]))
}